import { render, staticRenderFns } from "./DetailLhu.vue?vue&type=template&id=19cce091&scoped=true&"
import script from "./DetailLhu.vue?vue&type=script&lang=js&"
export * from "./DetailLhu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cce091",
  null
  
)

export default component.exports